module.exports = __webpack_public_path__ + "01_bob_grey.fc3e97d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_bob_grey.png
// module id = akQz
// module chunks = 0